// Utilitário para substituição de variáveis em mensagens SMS
export const replaceVariables = (message: string, variables: Record<string, string | number>): string => {
  let processedMessage = message;
  
  Object.entries(variables).forEach(([key, value]) => {
    const placeholder = `{${key}}`;
    processedMessage = processedMessage.replace(new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g'), String(value));
  });
  
  return processedMessage;
};

export const validateSmsMessage = (message: string): { isValid: boolean; error?: string } => {
  if (!message) {
    return { isValid: false, error: "Mensagem não pode estar vazia" };
  }
  
  if (message.length > 160) {
    return { isValid: false, error: "Mensagem não pode exceder 160 caracteres" };
  }
  
  return { isValid: true };
};

export const getAvailableVariables = () => [
  'customer_name',
  'coupon_code', 
  'coupon_value',
  'minimum_purchase_amount'
];

export const previewSmsMessage = (message: string) => {
  const sampleVariables = {
    customer_name: 'João Silva',
    coupon_code: 'CASHBACK20',
    coupon_value: '20',
    minimum_purchase_amount: '100'
  };
  
  return replaceVariables(message, sampleVariables);
};